import React from 'react'
import { Card } from 'react-bootstrap'

function CardBasic({className,className2,className3,header,children,style}) {
  return (
    <>
        <Card className={className} style={style}>
            {header && <Card.Header className={className3}>{header}</Card.Header>}
            <Card.Body className={className2}>
                {children}
            </Card.Body>
        </Card>
    </>
  )
}

export default CardBasic